// changing this may significantly increase the number
// of request to Microsotf Autocomplete API
export const autocompleteTimeout = 500; //ms

// year-range to display on registration form when choosing a year of birth
// the starting year will be calculated as {current year} - {18 years minimum} - {this config amount}
export const yearsRangeDateOfBirth = 80

// hCaptcha Site Key
export const reCaptchaSiteKey = "6LfdUMIZAAAAAMER-vG7ZiLqio7xalLYoRcUmQVv";